<template>
  <div>
    <div class="box" :value="confirmEvent">
      <div class="border-box">
        <div class="inner-box">
          <BInputText
            label-text="专业名称"
            :required="true"
            v-model="majorInfo.trainMajorName"
            :maxLength = "20"
            placeholder="请输入专业名称"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BInputText from "../../../components2/BInputText";
import Vue from "vue";
import { majorSave, majorUpdate } from "@/api/course";

export default {
  name: "MajorAddDialog",
  props: {
    data: Object,
    confirmEvent: Boolean
  },
  components: {
    BInputText,
  },
  watch: {
    confirmEvent() {
      if (this.confirmEvent === true || this.confirmEvent === null) {
         this.addMajor();
      }
    },
  },
  data() {
    return {
      returnData: "",
      majorInfo: {},
    };
  },
  mounted() {
    if (
      this.data.majorInfo !== null &&
      this.data.majorInfo !== "" &&
      this.data.majorInfo !== undefined
    ) {
      this.majorInfo = this.data.majorInfo;
    }
  },
  methods: {
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    addMajor() {
      // 班级名称
      if (
        this.majorInfo.trainMajorName === null
         || this.majorInfo.trainMajorName === "" 
         || this.majorInfo.trainMajorName === undefined) {
         Vue.prototype.$valertbar.show("请输入专业名称！");
        // 返回失败
        this.result(0);
      } else if (this.majorInfo.trainMajorName.length > 20 ) {
        Vue.prototype.$valertbar.show("专业名称长度不能超过20位！");
        // 返回失败
        this.result(0);
      }
      this.majorInfo.trainMajorName = this.comUtils.trim(this.majorInfo.trainMajorName);
     
      if (this.majorInfo.id !== ""
           && this.majorInfo.id !== null
           && this.majorInfo.id !== undefined) {
        this.update();
      } else {
        this.save();
      }
    },
    async save() {
      const data = await majorSave(this.majorInfo);
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        // （保存成功）向主页面返回信息
        this.result(2);
        // 关闭弹层
        this.$emit("input", false);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
        // 返回失败
        this.result(0);
      }
    },
    async update() {
      const data = await majorUpdate(this.majorInfo);

      if (data.data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.data.msg);
        // （保存成功）向主页面返回信息
        this.result(2);
        // 关闭弹层
        this.$emit("input", false);
      } else {
        Vue.prototype.$valertbar.show(data.data.msg);
        // 返回失败
        this.result(0);
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.border-box {
  display: flex;
  width: 400px;
  height: 100px;
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
}
</style>
